import LazyLoadImage from '@fingo/lib/components/images/LazyLoadImage';
import FingoNavbar from '@fingo/lib/components/layout/FingoNavbar';
import LoggedOutMobileNavItems from '@fingo/lib/components/layout/navbar/LoggedOutMobileNavItems';
import LogoWithRedirectLink from '@fingo/lib/components/logo/LogoWithRedirectLink';
import { useGetUser, useIsLogged } from '@fingo/lib/hooks';
import React, { useMemo } from 'react';
import LoggedInNavItems from '@fingo/lib/components/layout/navbar/LoggedInMobileNavItems';
import BancoDeChileLogo from '@fingo/lib/assets/icons/logos/banco_de_chile';
import useWorkspaceRoutes from '../../../hooks/useWorkspaceRoutes';

const MobileNavbar = () => {
  const isLogged = useIsLogged();
  const user = useGetUser();
  const routes = useWorkspaceRoutes().filter(({ showInNavbar }) => showInNavbar);
  const navbar = useMemo(() => (
    <FingoNavbar useGradient={false}>
      <LogoWithRedirectLink
        image={(
          <LazyLoadImage
            src={BancoDeChileLogo}
            alt="banco-de-chile logo"
            width={212}
            height={34}
            format="avif"
          />
        )}
        isLogged={isLogged}
      />
      {isLogged && user && <LoggedInNavItems routes={routes} />}
      {!isLogged && <LoggedOutMobileNavItems title="Iniciar Sesión" to="/login" />}
    </FingoNavbar>

  ), [isLogged, user, routes]);
  return navbar;
};

export default MobileNavbar;
